// ТЕКСТЫ ОШИБОК САБМИТА — четыре слота и карта «класс проблемы → слот». B10-3.
//
// ИСТОЧНИК БУКВЫ — решение `s926.d2` (Notion `3e919875cbb8813d8013d2857861ddd9`, Кирилл 28.09;
// слот 3 окончательно `s932`, слот 4 окончательно `s929`). Здесь перенос буква-в-букву, включая
// прямые кавычки в слоте 3 и прямые апострофы — как в записи. Правка текста идёт в Notion, сюда
// приезжает следом.
//
// ⚠️ `message` у `SubmitProblem` — технический английский контракта, он сверяется тестами и
// человеку НЕ показывается. Человеку показывается строка слота. Показ — B10-4.
//
// До проверки доходят ровно четыре класса (замер cc-153, блок 10 §4 п. 3); всё остальное из
// 19 классов контракта закрыто формой конверта и гейтами и слота не получает — `slotOf` вернёт
// `null`, и тест B10-3 требует, чтобы ни один достижимый класс так не кончался.
// ⚠️ Перемерено qa блока 10 (cc-193, `s972.d2`): слоты 2 («год не читается») и 3 (`__cust`) с конверта до
// проверки не доходят — их держит юнит; нечитаемое имя этапа доходит (только руками), слота не получает и
// уходит в слот 4. Разметка по классам — шапка `submitCopy.test.js`.

/** Слоты — ключи по соседним копи-узлам (`s7Copy.js`): `<узел>.<слот>`. */
export const SUBMIT_COPY = {
  /** 1 · ползунок вне ∓3 (`sliders[i]`, шаг 3). */
  'submit.slider': 'one slider on this stage is off the scale — move it to set it again',
  /** 2 · годы этапа не читаются или интервал перевёрнут (`stages[i]`, шаг 2). */
  'submit.dates': "the dates on this stage don't line up. fix them to continue",
  /** 3 · свой вариант выбран, текст пуст (`__cust`, `buttons[i]`, шаг 3). */
  'submit.custom': '"something else" is still blank. write it in, or pick another option',
  /** 4 · конверт не читается, адреса нет (`step: 0`) — «начать заново» (`s929`). */
  'submit.envelope': "part of your saved answers couldn't be read. start over to build your map",
};

/**
 * Слот для проблемы `wizardSubmitCheck`. `null` — класс, до которого живой путь не доходит.
 * @param {{field: string, step: number, message: string}} problem
 * @returns {keyof SUBMIT_COPY | null}
 */
export function slotOf(problem) {
  if (!problem) return null;
  if (problem.step === 0) return 'submit.envelope';
  const { field, message } = problem;
  if (field === 'sliders' && /outside the slider range/.test(message)) return 'submit.slider';
  if (field === 'stages' && /must be a decimal year|interval is inverted/.test(message)) return 'submit.dates';
  if (field === 'buttons' && /still carries the __cust sentinel/.test(message)) return 'submit.custom';
  return null;
}

/**
 * Слот для броска `toWizardInput` до проверки: рассинхрон длин шагов 2 и 3 (`toWizardInput.js`,
 * `wizard state is misaligned`) — правка конверта руками, слот 4 (`s929`). Ловит его B10-4.
 * @param {unknown} error
 */
export function slotOfError(error) {
  const msg = error && typeof error === 'object' && 'message' in error ? String(error.message) : String(error);
  return /wizard state is misaligned/.test(msg) ? 'submit.envelope' : null;
}
